// @module NetScore.PDPImageSwatch.PDPImageSwatch
define('NetScore.PDPImageSwatch.PDPImageSwatch.View'
,	[
		'netscore_pdpimageswatch_pdpimageswatch.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		netscore_pdpimageswatch_pdpimageswatch_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';
	// var pdp,
	// 	firstImage;

	// @class NetScore.PDPImageSwatch.PDPImageSwatch.View @extends Backbone.View
	return Backbone.View.extend({

		template: netscore_pdpimageswatch_pdpimageswatch_tpl

	,	initialize: function (options) {
			// var result=[];
			// this.pdp=options.PDP_info;
			// console.log('this.pdp',this.pdp);
			// var item_info=this.pdp.getItemInfo();
			// console.log('item_info',item_info);
			// var images_arr=item_info.item.itemimages_detail;
			// console.log('images_arr',images_arr);
			//  result = Utils.imageFlatten(images_arr);
			//  console.log('result',result);
   //          if (result.length > 1) {
   //             // var firstImage_1 = this.getFirstImage(result);
   //             firstImage=result[1].url;
   //              // result = _.filter(result, function (image) {
   //              //     return firstImage!= image;
   //              // });
   //              console.log('firstImage',firstImage);
   //              // result.unshift(firstImage);
   //          }

		}

	,	events: {
		
		}

	,	bindings: {
		
		}

	, 	childViews: {
			
		}

		//@method getContext @return NetScore.PDPImageSwatch.PDPImageSwatch.View.Context
	,	getContext: function getContext()
		{
			//@class NetScore.PDPImageSwatch.PDPImageSwatch.View.Context
			// this.message = this.message || 'Hello World!!'
			// return {
			// 	// message: this.message
			// 	firstImage:firstImage
			// };
		}
	});
});
